module.exports = __webpack_public_path__ + "img/public_icon.781752f5.png";